import { useAppTheme } from "../../hooks/useAppTheme";
import { IconButton, Tooltip } from "@mui/material";
import { LightMode, DarkMode } from "@mui/icons-material";

export default function ModeToggle() {
    const { toggleTheme, mode } = useAppTheme();

    return (
        <Tooltip title={`Switch to ${mode === 'light' ? 'dark' : 'light'} mode`}>
            <IconButton
                onClick={toggleTheme}
                color="inherit"
                size="small"
                sx={{
                    '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.08)',
                    },
                }}
            >
                {mode === 'light' ? <DarkMode /> : <LightMode />}
            </IconButton>
        </Tooltip>
    );
}